// Pre-fetch all media-gallery <img> resources after window.load + idle.
//
// The gallery uses loading="lazy" so non-visible variant images don't compete
// with LCP — but that means when a customer switches variants and
// setActiveMedia makes a different <li> active, the <img> inside it might
// not be downloaded yet. The browser fetches it on-demand and the customer
// sees a brief blank/old-image moment before the new image paints.
//
// By creating an offscreen `new Image()` with the same srcset + sizes after
// the page is idle, we trigger the browser to fetch the resource at low
// priority and cache it in HTTP cache. When the lazy <img> in the gallery
// is later told to load (via setActiveMedia making it `is-active`), the
// fetch resolves from cache instantly — no network roundtrip, no visible
// delay.
//
// Pattern mirrors warmVideoPosterCache in assets/product-family-selector.js,
// just for product gallery images instead of video posters.

(function () {
  function preloadGalleryImages() {
    var images = document.querySelectorAll('media-gallery img');
    var challenger = document.documentElement.classList.contains('gallery-challenger');
    var warmed = 0;
    images.forEach(function (img) {
      // Skip the eager (LCP) image — already downloaded.
      // Skip anything that's already complete (e.g. cached, or eager loaded).
      if (img.loading === 'eager') return;
      if (img.complete && img.naturalWidth > 0) return;

      // Gallery A/B test (TASKS.md #149): warm only the arm the shopper sees.
      // A gallery still waiting for its arm skips both; the test's gate runs
      // this again once the arm is known.
      var armItem = img.closest('[data-gallery-arm]');
      if (armItem) {
        if (armItem.closest('[data-gallery-test-pending]')) return;
        if ((armItem.getAttribute('data-gallery-arm') === 'challenger') !== challenger) return;
      }

      var preloader = new Image();
      preloader.decoding = 'async';
      // Preserve srcset + sizes so the browser picks the SAME URL the
      // gallery <img> would pick when shown. Setting src last so the
      // browser doesn't kick off two fetches.
      if (img.srcset) preloader.srcset = img.srcset;
      if (img.sizes) preloader.sizes = img.sizes;
      if (img.src) preloader.src = img.src;
      warmed++;
    });
    // Optional: leave a breadcrumb for QA / future debugging.
    if (warmed > 0 && window.console && console.debug) {
      console.debug('[variant-image-preload] warmed', warmed, 'gallery images');
    }
  }

  function schedule() {
    var idle =
      window.requestIdleCallback ||
      function (cb) {
        return setTimeout(cb, 1000);
      };
    idle(preloadGalleryImages, { timeout: 3000 });
  }

  // Expose so the homepage product switcher can re-trigger the scan
  // after Section Rendering API injects a new <media-gallery>. The
  // window.load auto-run below fires while the homepage skeleton is
  // still up, so it finds nothing — the embedded PDP only mounts later,
  // after the switcher's fetch resolves. Idempotent: the per-image
  // guard (`img.complete && naturalWidth > 0`) skips already-cached
  // images, and Image() with the same src is a no-op for the browser
  // when the resource is in HTTP cache.
  window.__variantImagePreloadRun = schedule;

  // Auto-run once on initial page load — guarded so a second load of
  // this script on the same page doesn't double-schedule.
  if (window.__variantImagePreloadStarted) return;
  window.__variantImagePreloadStarted = true;

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }
})();
